import * as Comlink from "comlink"
import * as Sentry from "@sentry/browser";
import { firebaseConfig } from "../../firebaseConfig";
const isBrowser = () => typeof window !== "undefined"
const preview = ({ title, premium }) => premium ? title : `Preview of ${title}`

// These are all supposed to be automatically collected by enhanced events. However, the way I'm doing these at moment precludes
// using the automatic settings, so I'm sending them this way. For future reference, videojs does not yet implement the JS API
// that YouTube has made the standard for video players and downloads have to call a cloud function to get an authenticated link.

const videoComplete = ({ currentTime, duration, percent, title, premium }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "video_complete", {
    video_current_time: currentTime,
    video_duration: duration,
    video_percent: percent,
    video_title: preview({ title, premium }),
  });
};

const videoDownload = ({ fileExtension, fileName, linkUrl, linkText }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "file_download", {
    file_extension: fileExtension,
    file_name: fileName,
    link_url: linkUrl,
    link_text: linkText,
  });
};

const videoProgress = ({ currentTime, duration, percent, title, premium }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "video_progress", {
    video_current_time: currentTime,
    video_duration: duration,
    video_percent: percent,
    video_title: preview({ title, premium }),
  });
};

const trackStream = async ({ seconds, duration, slug, uid, vid }) => {
  if(!isBrowser()) return;
  if(seconds === 0) return;
  slug = slug.replace(/\//g, '');

  const worker = new Worker("/workers/main.js");
  const obj = Comlink.wrap(worker);
  await obj.trackStream({ firebaseConfig, sec: seconds, duration, slug, uid, vid });
  const error = await obj.error;
  if (error) Sentry.captureException(error);
};

const videoStart = ({ currentTime, duration, percent, title, premium }) => {
  if(!isBrowser()) return;
  if(typeof window.gtag !== 'function') return;
  window.gtag("event", "video_start", {
    video_current_time: currentTime,
    video_duration: duration,
    video_percent: percent,
    video_title: preview({ title, premium }),
  });
};

export { trackStream, videoComplete, videoDownload, videoProgress, videoStart };
